export class StatusReportFilter {
  publisherIds?: string[] = [];
  salesRepresentativeEmail?: string;
}
